<template>
  <div>
    <toggle-header :id="'armor-details-' + this._uid" v-model="toggleState">Armor</toggle-header>

    <armor-details :toggleState="toggleState"></armor-details>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ArmorDetails from "./details/_SavageWorlds.vue";
import ToggleHeader from "../shared/_ToggleHeader.vue";

export default {
  name: "character-defences-fifth-edition",
  components: {
    ArmorDetails,
    ToggleHeader
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: {
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      armorClass: state => state.characters.current.defense.armorClass
    })
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.ac {
  color: $gray-700;
}
</style>
